import React, { Component } from 'react';



export class EDLegendBox extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        ///Cella con con box colore e testo descrittivo
        const legend = this.props.legendCode;

        return (
              <>  
               <div class="column">
                    <div Id="wrapper">
                        <div class="columnContainer">

                               <svg xmlns="http://www.w3.org/2000/svg" version="1.1"   viewBox="0 0 20 20">
                                <g id="UrTavla">
                                    <circle class={legend.SvgClassName} cx="10" cy="10" r="8"></circle>
                                    <text x="50%" y="50%" text-anchor="middle" class="w" font-size="0.4em" font-family="inherit" dy=".3em">N°</text>
                                </g>
                                </svg>
                            <div class="details">
                                <p id="p1">{legend.Text}</p>
                            </div>
                        </div>
                    </div>
                </div>
              </>    
        );
    } 
}

EDLegendBox.defaultProps = {
    legendCode: 1
  }